export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./request-contact.vue?vue&type=template&id=1f0863ba&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/request-contact.vue?vue&type=template&id=1f0863ba&
// module id = 1404
// module chunks = 0